import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as services from "../services/services";
import logo from "../images/itaam-company-2.png";
import { clearMobileSession } from "./session";

const schema = yup.object().shape({
  username: yup
    .string()
    .email("กรุณากรอก Email ให้ถูกต้อง")
    .required("กรุณากรอก Email"),
  password: yup.string().required("กรุณากรอกรหัสผ่าน"),
});

export default function MobileLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { username: "", password: "" },
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("reset") === "1") {
      clearMobileSession();
      window.history.replaceState(null, "", "/mobile/login");
    }
  }, []);

  const onSubmit = async (data) => {
    try {
      clearMobileSession();

      const response = await services.login({
        username: data.username,
        password: data.password,
      });
      const result = response.data;

      if (!result.success) {
        toast.error(result.error || "เข้าสู่ระบบไม่สำเร็จ");
        return;
      }

      localStorage.setItem("accessToken", JSON.stringify(result.data.accessToken));

      try {
        const bowResponse = await services.loginBow({
          email: "test@example.com",
          password: 1234,
        });
        localStorage.setItem("bow_accessToken", bowResponse.data.access);
      } catch {
        toast.error("ไม่สามารถเชื่อมต่อกับระบบ BOW ได้");
        return;
      }

      navigate("/mobile", { replace: true });
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401) {
        toast.error("อีเมลหรือรหัสผ่านไม่ถูกต้อง");
      } else if (status === 403) {
        toast.error("บัญชีนี้ถูกระงับการใช้งาน");
      } else {
        toast.error(
          error?.response?.data?.error ||
            error?.message ||
            "เกิดข้อผิดพลาด กรุณาลองใหม่",
        );
      }
    }
  };


  return (
    <main className="min-h-screen bg-[#f6f7fb] flex justify-center">
      <Toaster />
      <section className="w-full max-w-[480px] min-h-screen bg-white px-5 py-8 flex flex-col justify-center">
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <div className="flex justify-center mb-8">
            <img src={logo} alt="Bow HIS" className="w-36" />
          </div>

          <h1 className="text-2xl font-bold text-[#172033] text-center mb-2">
            เข้าสู่ระบบ
          </h1>

          <div className="mb-4">
            <label className="text-sm font-semibold text-gray-700">Email</label>
            <input
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="Email"
              {...register("username")}
              className="w-full mt-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 focus:outline-none"
            />
            {errors.username && (
              <p className="text-red-500 text-xs mt-1">
                {errors.username.message}
              </p>
            )}
          </div>

          <div className="mb-3">
            <label className="text-sm font-semibold text-gray-700">
              รหัสผ่าน
            </label>
            <div className="relative mt-1">
              <input
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                placeholder="รหัสผ่าน"
                {...register("password")}
                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 focus:outline-none"
              />
              <button
                type="button"
                aria-label={showPassword ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-gray-500 hover:text-gray-700"
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">
                {errors.password.message}
              </p>
            )}
          </div>

          <div className="flex justify-end mb-6">
            <Link
              to="/auth/forgot-password?from=mobile"
              className="text-sm font-semibold text-[#e85f24] hover:underline"
            >
              ลืมรหัสผ่าน?
            </Link>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#e85f24] hover:bg-[#d8521d] disabled:bg-gray-300 text-white font-bold py-3 rounded-lg transition"
          >
            {isSubmitting ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
          </button>

          <p className="text-center text-sm text-gray-500 mt-6">
            ยังไม่มีบัญชี?{" "}
            <Link
              to="/auth/register"
              className="font-semibold text-[#e85f24] hover:underline"
            >
              สมัครสมาชิก
            </Link>
          </p>

        </form>
      </section>
    </main>
  );
}
